export const neurologyConst = {
  path: "/single-programs/neurology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — НЕВРОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Неврология — наука о мозге, движении и качестве жизни</h2>
      <p>
        Неврология — это фундаментальная медицинская дисциплина, посвященная изучению заболеваний центральной и периферической нервной
        системы. От инсульта и мигрени до эпилепсии и рассеянного склероза — невролог помогает людям сохранять двигательную активность,
        речь, память и самостоятельность.
      </p>
      <p>Программа построена на междисциплинарном подходе и включает как теоретическую подготовку, так и клиническую практику.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и физиология нервной системы</li>
        <li>Патофизиология и нейрохимия</li>
        <li>Диагностика и лечение неврологических заболеваний</li>
        <li>Эпилептология, рассеянный склероз, нейродегенеративные болезни</li>
        <li>Современная нейровизуализация (МРТ, КТ, ЭЭГ)</li>
        <li>Реабилитация пациентов после инсульта</li>
        <li>Боль и её нейрофизиология</li>
        <li>Невропсихология и взаимодействие с пациентами</li>
      </ul>
      <p>Обучение проходит в университетских клиниках, неврологических центрах и научных лабораториях.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-невролог в клиниках и госпиталях</li>
        <li>Нейрофизиолог — специалист по ЭЭГ, ЭМГ и функциональной диагностике</li>
        <li>Специалист по лечению хронической боли</li>
        <li>Консультант по нейродегенеративным заболеваниям</li>
        <li>Медицинский исследователь в области нейронаук</li>
        <li>Преподаватель, научный сотрудник или эксперт по реабилитации</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Неврологи востребованы в системах здравоохранения по всей Европе.</p>
      <p>
        <strong>Средний доход — от €65,000 до €115,000 в год,</strong> с перспективой карьерного роста и специализации.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра, признанный в странах ЕС</li>
        <li>Выбор языка обучения: русский или английский</li>
        <li>Дистанционная и очная форма на выбор</li>
        <li>Практика с передовыми технологиями нейровизуализации</li>
        <li>Стажировки в европейских клиниках и реабилитационных центрах</li>
        <li>Индивидуальное академическое сопровождение и помощь в трудоустройстве</li>
      </ul>
      <h2>Учёба, которая делает жизнь людей качественнее</h2>
      <p>Наши выпускники возвращают пациентам радость полноценной жизни после тяжелых неврологических заболеваний.</p>
      <br />
      <p className="padding-left">«Каждое движение — это чудо. Мы учим, как это чудо сохранять и восстанавливать.»</p>
      <h2>Как поступить?</h2>
      <p>Оставьте заявку, получите консультацию и подробности по поступлению, стоимости и срокам.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Неврология — наука о мозге, движении и качестве жизни
    Неврология — это фундаментальная медицинская дисциплина, посвященная изучению заболеваний центральной и периферической нервной системы. От инсульта и мигрени до эпилепсии и рассеянного склероза — невролог помогает людям сохранять двигательную активность, речь, память и самостоятельность.
    Программа построена на междисциплинарном подходе и включает как теоретическую подготовку, так и клиническую практику.

    Что вы будете изучать?
    • Анатомия и физиология нервной системы
    • Патофизиология и нейрохимия
    • Диагностика и лечение неврологических заболеваний
    • Эпилептология, рассеянный склероз, нейродегенеративные болезни
    • Современная нейровизуализация (МРТ, КТ, ЭЭГ)
    • Реабилитация пациентов после инсульта
    • Боль и её нейрофизиология
    • Невропсихология и взаимодействие с пациентами
    Обучение проходит в университетских клиниках, неврологических центрах и научных лабораториях.

    Кем можно работать после окончания?
    • Врач-невролог в клиниках и госпиталях
    • Нейрофизиолог — специалист по ЭЭГ, ЭМГ и функциональной диагностике
    • Специалист по лечению хронической боли
    • Консультант по нейродегенеративным заболеваниям
    • Медицинский исследователь в области нейронаук
    • Преподаватель, научный сотрудник или эксперт по реабилитации

    Востребованность и доход
    Неврологи востребованы в системах здравоохранения по всей Европе.
    Средний доход — от €65,000 до €115,000 в год, с перспективой карьерного роста и специализации.


    Почему выбирают нас?
    • Европейский диплом магистра, признанный в странах ЕС
    • Выбор языка обучения: русский или английский
    • Дистанционная и очная форма на выбор
    • Практика с передовыми технологиями нейровизуализации
    • Стажировки в европейских клиниках и реабилитационных центрах
    • Индивидуальное академическое сопровождение и помощь в трудоустройстве

    Учёба, которая помогает вернуть здоровье и движение
    Наши выпускники возвращают пациентам радость полноценной жизни после тяжелых неврологических заболеваний.
    «Каждое движение — это чудо. Мы учим, как это чудо сохранять и восстанавливать.»

    Как поступить?
    Оставьте заявку, получите консультацию и подробности по поступлению, стоимости и срокам. 
  `,
};
